<template>
  <b-button
    :disabled="disabled"
    :variant="variant"
    :to="to"
    @click="(onClick ? onClick : () => {})"
    @hover="(onHover ? onHover : () => {})"
    class="animated fadeIn mr-2 my-1"
  >
    <i v-if="faIcon" :class="`fal fa-${faIcon} ${shouldAnimate ? 'fa-spin' : ''}`" class="mr-2" />
    {{ label }}
  </b-button>
</template>

<script>
export default {
  name: "ContextPill",
  props: ["disabled", "variant", "to", "onClick", "onHover", "faIcon", "label", "shouldAnimate"],
};
</script>
